export const updateFilter = (filter, id, denomination = false) => {
    return filter.map((item) => {
        if (item.id === id && !denomination) {
            const newActiveState = !item.active;
            return {
                ...item,
                active: newActiveState,
                options: item.options.map((option) => ({
                    ...option,
                    active: newActiveState
                }))
            };
        } else {
            const optionsUpdated = item.options.map((option) => {
                if (option.id === id) {
                    return {
                        ...option,
                        active: !option.active
                    };
                }
                return option;
            });

            if (
                optionsUpdated.some(
                    (option, index) => option !== item.options[index]
                )
            ) {
                return {
                    ...item,
                    options: optionsUpdated
                };
            }
            return item;
        }
    });
};
